import { faAlarmExclamation } from '@fortawesome/pro-regular-svg-icons/faAlarmExclamation'
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faArrowCircleDown } from '@fortawesome/pro-regular-svg-icons/faArrowCircleDown'
import { faArrowLeft as faArrowLeftRegular } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faArrowRight as faArrowRightRegular } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faAt } from '@fortawesome/pro-regular-svg-icons/faAt'
import { faBolt as faBoltRegular } from '@fortawesome/pro-regular-svg-icons/faBolt'
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine'
import { faCheck as faCheckRegular } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { faCog as faCogRegular } from '@fortawesome/pro-regular-svg-icons/faCog'
import { faCogs } from '@fortawesome/pro-regular-svg-icons/faCogs'
import { faCommentAltLines } from '@fortawesome/pro-regular-svg-icons/faCommentAltLines'
import { faComments } from '@fortawesome/pro-regular-svg-icons/faComments'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload'
import { faEllipsisH as faEllipsisHRegular } from '@fortawesome/pro-regular-svg-icons/faEllipsisH'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { faFileDownload as faFileDownloadRegular } from '@fortawesome/pro-regular-svg-icons/faFileDownload'
import { faHandPointer } from '@fortawesome/pro-regular-svg-icons/faHandPointer'
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage'
import { faInfo } from '@fortawesome/pro-regular-svg-icons/faInfo'
import { faLaugh } from '@fortawesome/pro-regular-svg-icons/faLaugh'
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons/faLightbulbOn'
import { faList } from '@fortawesome/pro-regular-svg-icons/faList'
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faSignalStream } from '@fortawesome/pro-regular-svg-icons/faSignalStream'
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons/faStar'
import { faStopwatch } from '@fortawesome/pro-regular-svg-icons/faStopwatch'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faTrash as faTrashRegular } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { faUserChart } from '@fortawesome/pro-regular-svg-icons/faUserChart'
import { faUserFriends } from '@fortawesome/pro-regular-svg-icons/faUserFriends'
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers'
import { faWebcam } from '@fortawesome/pro-regular-svg-icons/faWebcam'
import { faExternalLinkSquareAlt } from '@fortawesome/pro-regular-svg-icons/faExternalLinkSquareAlt'
import { faClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo'

const regularIcons = [
  faAlarmExclamation,
  faAngleLeft,
  faAngleRight,
  faArrowCircleDown,
  faArrowLeftRegular,
  faArrowRightRegular,
  faAt,
  faBoltRegular,
  faCalendarAlt,
  faChartLine,
  faCheckRegular,
  faClock,
  faCogRegular,
  faCogs,
  faCommentAltLines,
  faComments,
  faCopy,
  faDownload,
  faEllipsisHRegular,
  faExclamationTriangle,
  faFileDownloadRegular,
  faHandPointer,
  faImage,
  faInfo,
  faLaugh,
  faLightbulbOn,
  faList,
  faPen,
  faPlus,
  faSearch,
  faSignalStream,
  faStarRegular,
  faStopwatch,
  faTimes,
  faTrashAlt,
  faTrashRegular,
  faUserChart,
  faUserFriends,
  faUsers,
  faWebcam,
  faExternalLinkSquareAlt,
  faClipboard,
  faInfoCircle,
  faVideo
]

export default regularIcons
